export default __webpack_public_path__ + "static/media/externalOn.756222d8.svg";